export enum FormPanelType {
    customerEmail = 'CUSTOMER_EMAIL',
    invoiceData = 'INVOICE_DATA',
    notes = 'NOTES',
    payment = 'PAYMENT',
    realizationDate = 'REALIZATION_DATE',
    recipientData = 'RECIPIENT_DATA',
    shipmentData = 'SHIPMENT_DATA',
    shipmentForm = 'SHIPMENT_FORM',
}

export enum FormFieldNames {
    BILLING_ADDRESS = 'billingAddress',
    CITY = 'city',
    COMPANY = 'company',
    CUSTOMER_EMAIL = 'email',
    COUNSEL_PARENTS = 'COUNSEL_PARENTS',
    DIFFERENT_DATA = 'differentData',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    NOTES = 'notes',
    ORDER_TYPE = 'orderType',
    PAYER_ADDRESS = 'payerAddress',
    PAYMENT_METHOD = 'paymentMethod',
    PHONE_NUMBER = 'phoneNumber',
    POST_CODE = 'postcode',
    REALIZATION_DATE = 'realizationDate',
    SCHOOL = 'SCHOOL',
    SCHOOL_EMAIL = 'schoolEmail',
    SHIPPING_ADDRESS = 'shippingAddress',
    SHIPPING_FORM = 'shippingForm',
    STREET = 'street',
    STREET_NUMBER = 'streetNumber',
    TAX_ID_NUMBER = 'taxIdNumber',
}

export const {
    BILLING_ADDRESS,
    CITY,
    COMPANY,
    COUNSEL_PARENTS,
    CUSTOMER_EMAIL,
    DIFFERENT_DATA,
    FIRST_NAME,
    LAST_NAME,
    NOTES,
    ORDER_TYPE,
    PAYER_ADDRESS,
    PAYMENT_METHOD,
    PHONE_NUMBER,
    POST_CODE,
    REALIZATION_DATE,
    SCHOOL,
    SCHOOL_EMAIL,
    SHIPPING_ADDRESS,
    SHIPPING_FORM,
    STREET,
    STREET_NUMBER,
    TAX_ID_NUMBER,
} = FormFieldNames;
